import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const Impersonate: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const hash = window.location.hash.startsWith('#')
        ? window.location.hash.slice(1)
        : window.location.hash;
      const params = new URLSearchParams(hash);
      const access_token = params.get('at');
      const refresh_token = params.get('rt');
      const return_to = params.get('return_to') || '/admin/dashboard';

      if (!access_token || !refresh_token) {
        setError('Nedostaje token u URL-u.');
        return;
      }

      const { error: sessErr } = await supabase.auth.setSession({
        access_token,
        refresh_token,
      });
      if (sessErr) {
        setError(sessErr.message);
        return;
      }
      window.history.replaceState({}, '', window.location.pathname);
      navigate(return_to, { replace: true });
    })();
  }, [navigate]);

  return (
    <div style={{ padding: 40, fontFamily: 'system-ui, sans-serif' }}>
      {error ? (
        <div style={{ color: '#dc2626' }}>Impersonate greška: {error}</div>
      ) : (
        <div>Logujem te kao izabranog korisnika…</div>
      )}
    </div>
  );
};

export default Impersonate;
